import { LOADING_THEME, CHANGE_THEME } from './types/appTypes';

export const loadingTheme = status => dispatch => dispatch({ type: LOADING_THEME, result: status });
export const changeTheme = themeConfig => dispatch => dispatch({ type: CHANGE_THEME, result: themeConfig });



// WEBPACK FOOTER //
// ./src/redux/actions/appActions.js